import { render } from "./EventsListChart.vue?vue&type=template&id=32e442ca&scoped=true"
import script from "./EventsListChart.vue?vue&type=script&lang=js"
export * from "./EventsListChart.vue?vue&type=script&lang=js"

import "./EventsListChart.vue?vue&type=style&index=0&id=32e442ca&lang=css&scoped=true"

import exportComponent from "/data/projects/dev_private_futurelab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32e442ca"]])

export default __exports__